/**
 * PageHeader Styles
 * Styles for the PageHeader component
 */

import { StyleSheet } from 'react-native';

export const pageHeaderStyles = StyleSheet.create({
  headerOverride: {
    justifyContent: 'space-between',
    gap: 0,
  },
  spacer: {
    flex: 1,
  },
  rightActions: {
    flexDirection: 'row',
    alignItems: 'center',
    // Keep the bell tight to the hamburger menu (especially on smaller screens).
    gap: 2,
  },
  /** Org context chip + existing left content (coin chip etc.) — gap stays tight to fit in 60px header. */
  leftCluster: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  headerAvatar: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerAvatarPressed: {
    opacity: 0.65,
  },
  headerAvatarHover: {
    opacity: 0.85,
  },
});







